import * as React from 'react';
import {
  Editable,
  fetchApi,
  makeResetCache,
  notifyError,
  notifyResponse,
  PageTitle,
  Section,
  selectUser,
  UserState,
} from 'gossamer-front-end';
import { FieldType } from 'gossamer-unified';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { AdminInstitutionMemberInviteRequest, InstitutionMemberInvite } from 'cb-model';
import { CustomInfo } from 'cb-unified';

interface AddNewMemberProps {
  inviteType?: 'member' | 'admin';
}

export const AddNewMember = (props: AddNewMemberProps): React.JSX.Element => {
  const [email, setEmail] = React.useState<string>('');
  const user = useSelector((state: { user: UserState }) => selectUser(state));
  const dispatch = useDispatch();
  const resetCache = makeResetCache(dispatch);
  const inviteType = props.inviteType || 'member';
  const isAdminInvite = inviteType === 'admin';

  const handleSubmit = async () => {
    try {
      const response = await fetchApi('POST', `/main/institution-member-invite`, {
        institutionId: (user.customInfo as CustomInfo)?.adminInstitutionId,
        invites: [
          {
            emailAddress: email,
            toBeAdmin: isAdminInvite,
          },
        ],
      } as AdminInstitutionMemberInviteRequest);
      notifyResponse(response);
      resetCache(InstitutionMemberInvite.id);
      setEmail('');
    } catch (e) {
      notifyError(e, `An error occurred while inviting the ${inviteType}`);
    }
  };
  return (
    <>
      <PageTitle
        title={isAdminInvite ? 'Invite an Admin to this Institution' : 'Invite a Member to this Institution'}
        subtitle={
          isAdminInvite
            ? 'If this person already has a Careerbook account then they will be made an admin of this institution straight away, otherwise they will receive an invitation email'
            : 'If this person already has a Careerbook account then they will be made a member of this institution straight away, otherwise they will receive an invitation email'
        }
      />
      <Section>
        <Editable
          field={{
            seq: 0,
            type: FieldType.Text,
            label: 'Email address',
            staticPrefix: 'Email address',
          }}
          value={email}
          handleChange={setEmail}
          handleBlur={setEmail}
        />
        <div className="mb20px" />
        <Button size="sm" variant="primary" onClick={handleSubmit} disabled={!email}>
          {isAdminInvite ? 'Invite Admin' : 'Invite Member'}
        </Button>
      </Section>
    </>
  );
};
